export default {
  sendOtpCode() {
    return {
      data: {
        status: 'SUCCESS',
        data: true,
      },
    };
  },
  validateOtpCode() {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          data: {
            app_num: '2C3FE347-A01F-498E-A3BD-15D780A121B0',
            otp_num: 324168,
            validation_status: 'SUCCESS',
          },
        });
      }, 5000);
    });
  },
};
